import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import ProductsList from './ProductsListComponent';
import actions from '../actions';
import coreActions from '../../core/actions';

const allActions = { ...actions, ...coreActions };

const mapStateToProps = (state, props) => ({
  items: state.products,
  productTemplates: state.productSettingsTemplates,
  ...state.productSettings,
  ...state.config,
  runtimeConfig: props.runtimeConfig,
});

const mapDispatchToProps = (dispatch) => ({ actions: bindActionCreators(allActions, dispatch) });

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProductsList));
